/* Phones that can hand a PDF to the share sheet get "Share"; everything else keeps the print route.
 * Kept apart from share-pdf.ts so the capture code only loads when someone shares. */
export function canSharePdf(): boolean {
  try {
    const touch = matchMedia('(pointer: coarse)').matches;
    return touch && !!navigator.canShare && navigator.canShare({ files: [new File([new Uint8Array(1)], 'r.pdf', { type: 'application/pdf' })] });
  } catch { return false; }
}
